import React, {createContext, useContext, useState} from 'react';

const TreeMenuNewContext = createContext(null);

export const TreeMenuNewProvider = (props) => {
  const [actives, setActives] = useState({})

  return (
    <TreeMenuNewContext.Provider
      value={{
        actives,
        setActives,
        isMulti: props.isMulti,
        displayType: props.displayType,
      }}
    >
      {props.children}
    </TreeMenuNewContext.Provider>
  );
};

export const useTreeMenuNew = () => {
  return useContext(TreeMenuNewContext);
};